module.exports = __webpack_public_path__ + "static/dacm-a8b40dd2f34bcf8ec2cd7a5596144c08.svg";